export type EntitlementSource =
  | 'admin'
  | 'free'
  | 'membership'
  | 'content_access'
  | 'enrollment'
  | 'program_access';

type EntitlementProof = {
  source: EntitlementSource;
  hasAccess: boolean;
};

type EntitlementLoadingCheck = {
  isLoading: boolean;
  mode: 'always' | 'until-access';
};

type ResolveEntitlementArgs = {
  proofs: EntitlementProof[];
  loadingChecks?: EntitlementLoadingCheck[];
};

export type EntitlementDecision = {
  hasAccess: boolean;
  accessSource: EntitlementSource | null;
  isPending: boolean;
  shouldBlockRender: boolean;
  shouldShowAccessFallback: boolean;
};

export function resolveEntitlement({
  proofs,
  loadingChecks = [],
}: ResolveEntitlementArgs): EntitlementDecision {
  const accessProof = proofs.find((proof) => proof.hasAccess) ?? null;
  const hasAccess = Boolean(accessProof);
  const isPending = loadingChecks.some((check) => {
    if (!check.isLoading) return false;
    return check.mode === 'always' || !hasAccess;
  });

  return {
    hasAccess,
    accessSource: accessProof?.source ?? null,
    isPending,
    shouldBlockRender: isPending,
    shouldShowAccessFallback: !hasAccess && !isPending,
  };
}
